module.exports = __webpack_public_path__ + "static/media/icon-contact-instagram.4de1d905.png";